import { createAction, props } from '@ngrx/store';
import { LocationResponseContract } from '@polaris-customerweb/sharedcomponents.core';

export enum VehicleLocationActions {
    getVehicleLocation = '[vehicleLocation] get vehicle location',
    getVehicleLocationSuccess = '[vehicleLocation] get vehicle location success',
    getVehicleLocationFail = '[vehicleLocation] get vehicle location fail',
    getAllVehicleLocations = '[vehicleLocation] get all vehicle locations',
    getAllVehicleLocationsSuccess = '[vehicleLocation] get all vehicle locations success',
    getAllVehicleLocationsFail = '[vehicleLocation] get all vehicle locations fail',
    setIsPollingAllVehicleLocations = '[vehicleLocation] set is polling all vehicle locations',
    setIsPollingActiveVehicleLocation = '[vehicleLocation] set is polling active vehicle location',
}

export const GetVehicleLocation = createAction(
    VehicleLocationActions.getVehicleLocation,
    props<{
        vin: string;
    }>()
);

export const GetVehicleLocationSuccess = createAction(
    VehicleLocationActions.getVehicleLocationSuccess,
    props<{ locationResponse: LocationResponseContract }>()
);

export const GetVehicleLocationFail = createAction(
    VehicleLocationActions.getVehicleLocationFail,
    props<{ vin: string; errorMessage: string }>()
);

export const GetAllVehicleLocations = createAction(
    VehicleLocationActions.getAllVehicleLocations
);

export const GetAllVehicleLocationsSuccess = createAction(
    VehicleLocationActions.getAllVehicleLocationsSuccess,
    props<{ locationResponses: LocationResponseContract[] }>()
);

export const GetAllVehicleLocationsFail = createAction(
    VehicleLocationActions.getAllVehicleLocationsFail,
    props<{ errorMessage: string; vins: string[] }>()
);

export const SetIsPollingAllVehicleLocations = createAction(
    VehicleLocationActions.setIsPollingAllVehicleLocations,
    props<{ isPolling: boolean }>()
);

export const SetIsPollingActiveVehicleLocation = createAction(
    VehicleLocationActions.setIsPollingActiveVehicleLocation,
    props<{ isPolling: boolean }>()
);
